import md5 from 'crypto-js/md5';

export const shouldSelectForExperiment = (
  id: string,
  salt: string,
  percentage: number,
): boolean => {
  const combinedStr = id + salt;

  const hash = md5(combinedStr).toString();

  const val = parseInt(hash.substring(0, 4), 16);

  const moduloValue = val % 100;

  return moduloValue < percentage;
};
